import useSWR from "swr";
import { APIDecoratorWithBaseURI } from "../../Service/api";
import { AxiosError, AxiosResponse } from 'axios';

export interface useBankListProps {
  bankList: AxiosResponse<FetchResponse> | undefined,
  isLoading: boolean
  isError: AxiosError
}

export interface bankItemProps {
  id: number
  number: string
  name: string
}

interface FetchResponse {
  success: boolean;
  data: bankItemProps[];
}

export const useBankList = (): useBankListProps => {
    const url: string = 'producer/analytics/getBankList'

    const fetchData = async (): Promise<AxiosResponse>  => {
      return await APIDecoratorWithBaseURI().get(url); 
    }

    const { data, error, isLoading } = useSWR(url,fetchData)

    return {
      bankList: data,
      isLoading,
      isError: error
    }
}




